import React from 'react';
import { EntitlementEdition } from '@atlassian/cssxp-utils-entitlement';
import { FormattedDate } from '@css-xp/base';
import { getSandboxesDeletionDocUrl } from '@css-xp/ppc-navigation-partner-support-utils';

interface PlanChangeParams {
  initialOffering?: string;
  currentOffering?: string;
  isInTrial?: boolean;
  isItADowngrade?: boolean;
  isItAUpgrade?: boolean;
  startDate?: string;
  isATransferCase?: boolean;
}

export const getPlanChangeContent = ({
  initialOffering,
  currentOffering,
  isInTrial,
  isItADowngrade,
  isItAUpgrade,
  startDate,
  isATransferCase,
}: PlanChangeParams) => {
  if (
    initialOffering?.toUpperCase() === EntitlementEdition.FREE &&
    currentOffering?.toUpperCase() === EntitlementEdition.STANDARD &&
    isInTrial
  ) {
    return 'Standard plan starts immediately. No charge during Standard trial period.';
  } else if (currentOffering?.toUpperCase() === EntitlementEdition.FREE && isItADowngrade) {
    return (
      <>
        Free plan starts immediately. Access to paid plan features will be lost. Any remaining days in the billing cycle
        will be non-refundable. If applicable, any sandbox instances will be removed and data will be deleted -{' '}
        <a href={getSandboxesDeletionDocUrl()} target="_blank">
          learn more.
        </a>
      </>
    );
  } else if (
    initialOffering?.toUpperCase() === EntitlementEdition.PREMIUM &&
    currentOffering?.toUpperCase() === EntitlementEdition.STANDARD
  ) {
    return (
      <>
        {startDate && !isInTrial && !isATransferCase && (
          <>
            Standard plan starts <FormattedDate date={startDate} />.
          </>
        )}{' '}
        Access to some Premium features will be lost. If applicable, any sandbox instances will be removed and data will
        be deleted -{' '}
        <a href={getSandboxesDeletionDocUrl()} target="_blank">
          learn more.
        </a>
      </>
    );
  } else if (isItADowngrade || isItAUpgrade) {
    return `New ${currentOffering?.toLowerCase()} plan starts immediately.`;
  }
};
